import { Component, Inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationFacade, Route, ShapeType, OpenTripPlannerFacade } from '@ridango/components';
import Env from '@ridango/core/env';
import { IonModalService } from '@ridango/core/lib/services/ion-modal.service';

@Component({
    selector: 'rwidget-explore-routes',
    templateUrl: './explore-routes.component.html',
    styleUrls: ['./explore-routes.component.scss']
})
export class ExploreRoutesComponent implements OnInit {
    @Input()
    set routes(value: Route[]) {
        if (value) {
            this._routesInput = value;
            this.updateDisplayRoutes();
        }
    }
    private _routesInput: Route[] = [];
    private otpRoutes: Route[] = [];
    displayRoutes: Route[] = [];

    public staticColor = this.env.EXPLORE?.ROUTE_STATIC_COLOR ?? null;
    public readonly assetsPath$ = this.applicationFacade.assetsPath$;
    public readonly ShapeType = ShapeType;

    constructor(
        @Inject('ENV') public env: Env,
        private applicationFacade: ApplicationFacade,
        private router: Router,
        private ionModalService: IonModalService,
        private translate: TranslateService,
        private otpFacade: OpenTripPlannerFacade
    ) {}

    ngOnInit(): void {
        this.otpFacade.routes$.subscribe((routes) => {
            this.otpRoutes = routes || [];
            this.updateDisplayRoutes();
        });
    }

    private updateDisplayRoutes(): void {
        const useOtpRoutes = this.env.EXPLORE?.USE_OTP_ROUTES_IN_COMPONENT;

        if (useOtpRoutes) {
            if (this.otpRoutes?.length > 0) {
                this.displayRoutes = this.otpRoutes;
            } else if (this._routesInput?.length > 0) {
                this.displayRoutes = this._routesInput;
            } else {
                this.displayRoutes = [];
            }
        } else {
            if (this._routesInput?.length > 0) {
                this.displayRoutes = this._routesInput;
            } else if (this.otpRoutes?.length > 0) {
                this.displayRoutes = this.otpRoutes;
            } else {
                this.displayRoutes = [];
            }
        }
    }

    public getColor(route: Route): string {
        return this.env.EXPLORE?.SHOW_ROUTE_GROUPS ? `#${route.color}` : route.color;
    }

    public getTextColor(route: Route): string {
        return route.icon?.textColor ?? '#FFFFFF';
    }

    public async redirectToRouteDetails(route: Route): Promise<void> {
        const id = this.env.EXPLORE?.SHOW_ROUTE_GROUPS ? route.gtfsId : route.id;

        this.ionModalService.scrollToTopTrigger();
        await this.router.navigate([this.translate.currentLang, 'explore', 'route', id, 'patterns']);
    }

    public trackById(_: number, route: Route): string {
        return route.id;
    }
}
